// removed by extract-text-webpack-plugin
module.exports = {"loadingDots":"src-components-common-DotLoader-styles__loadingDots--3pKAj","dot":"src-components-common-DotLoader-styles__dot--1D6rB","dot-keyframes":"src-components-common-DotLoader-styles__dot-keyframes--hUTlL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/DotLoader/styles.scss
// module id = 147
// module chunks = 0